import { Dimensions } from 'constants/types';
import React, { useEffect, useState } from 'react';

interface Props {
  imageData: string; // base64 encoded image
  imageOverlay?: React.ReactNode;
  imageStyle?: string;
  imageOverlayStyle?: string;
  onDoubleClick?: () => void;
  onClick?: () => void;
  isSelected?: boolean;
  dimensions: Dimensions;
  containerStyle?: React.CSSProperties;
}

const ImageRenderer = (props: Props) => {
  const {
    imageData,
    imageOverlay,
    imageStyle,
    imageOverlayStyle,
    onDoubleClick,
    onClick,
    dimensions,
    containerStyle,
  } = props;
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (!imageData) {
      return;
    }
    const img = new window.Image();
    img.src = imageData;
    img.onload = () => setImage(img);
  }, [imageData]);

  if (!image || !dimensions.width || !dimensions.height) {
    return null;
  }
  // calculating image height keeping aspect ratio intact
  const imageHeight = dimensions.width / (image.width / image.height);

  return (
    <div
      id='image-wrapper'
      className={imageStyle}
      style={containerStyle}
      onDoubleClick={onDoubleClick || null}
      onClick={onClick || null}
    >
      <img id='image-source' src={image.src} height={imageHeight} width={dimensions.width} />
      <div id='image-overlay' className={imageOverlayStyle}>{imageOverlay}</div>
    </div>
  );
};

export default ImageRenderer;
